import type { LessonBookmarkRecord } from "@circle-react/types/Bookmarks";
import { Typography } from "@circleco/compass/components/Typography";

export interface LessonProps {
  bookmark: LessonBookmarkRecord;
}

export const Lesson = ({ bookmark }: LessonProps) => {
  const { title, section, course } = bookmark.bookmark_record ?? {};

  return (
    <div className="flex flex-col gap-2.5">
      <Typography variant="label-xs" className="overflow-anywhere line-clamp-2">
        {course}
      </Typography>
      <div className="flex flex-col gap-1">
        <Typography
          variant="label-sm"
          className="overflow-anywhere line-clamp-2"
        >
          {title}
        </Typography>
        <Typography
          variant="caption"
          color="tertiary"
          className="overflow-anywhere line-clamp-2"
        >
          {section}
        </Typography>
      </div>
    </div>
  );
};
